import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';

@Component({
  selector: 'app-rfi-coverage-bar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './rfi-coverage-bar.component.html',
})
export class RfiCoverageBarComponent {
  readonly percent = input.required<number>();
  readonly fillClass = input('bg-emerald-500');
  readonly trackClass = input('bg-third-level');
  readonly sizeClass = input('h-2.5 rounded');

  protected readonly trackClasses = computed(
    () => `${this.trackClass()} ${this.sizeClass()} block overflow-hidden`,
  );
  protected readonly fillClasses = computed(() => `${this.fillClass()} block h-full`);
}
